export const blockIconsHouseholdFlatwareNew = (
	<span className='material-symbols-outlined'>flatware</span>
);
